const STORAGE_PREFIX = "peer-start-onboarding-answers:";

export interface OnboardingAnswers {
  roleId: string;
  careEnvironment: string;
  years: string;
  certificateName: string | null;
  diplomaName: string | null;
  domainIds: string[];
  missingTopic: string;
  challenge: string;
}

export const emptyOnboardingAnswers = (): OnboardingAnswers => ({
  roleId: "",
  careEnvironment: "",
  years: "",
  certificateName: null,
  diplomaName: null,
  domainIds: [],
  missingTopic: "",
  challenge: "",
});

export function loadOnboardingAnswers(employeeId: string): OnboardingAnswers | null {
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${employeeId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<OnboardingAnswers>;
    return {
      ...emptyOnboardingAnswers(),
      ...parsed,
      domainIds: Array.isArray(parsed.domainIds)
        ? parsed.domainIds.filter((id) => typeof id === "string")
        : [],
    };
  } catch {
    return null;
  }
}

export function saveOnboardingAnswers(employeeId: string, answers: OnboardingAnswers): void {
  localStorage.setItem(`${STORAGE_PREFIX}${employeeId}`, JSON.stringify(answers));
}

/** Demo fallbacks when onboarding was completed before answers were persisted locally. */
export function demoOnboardingAnswers(input: {
  roleId: string;
  workContext: string | null;
}): OnboardingAnswers {
  return {
    roleId: input.roleId,
    careEnvironment: "",
    years: "under-1",
    certificateName: null,
    diplomaName: "Pabo-getuigschrift.pdf",
    domainIds: ["CAP-01", "CAP-06"],
    missingTopic: "",
    challenge: "confidence",
  };
}

export function resolveOnboardingAnswers(input: {
  employeeId: string;
  roleId: string;
  workContext: string | null;
  onboardingComplete: boolean;
}): OnboardingAnswers {
  const stored = loadOnboardingAnswers(input.employeeId);
  if (stored) {
    return {
      ...stored,
      roleId: stored.roleId || input.roleId,
    };
  }
  if (!input.onboardingComplete) {
    return {
      ...emptyOnboardingAnswers(),
      roleId: input.roleId,
    };
  }
  return demoOnboardingAnswers({ roleId: input.roleId, workContext: input.workContext });
}
